// Google Consent Mode v2 helpers
// The default state is set in public/index.html BEFORE any Google scripts.
// This module reads/writes user consent to localStorage and pushes updates
// to gtag and dataLayer.

const STORAGE_KEY = "rv_consent";

export const DENIED_STATE = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

export const GRANTED_STATE = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
  functionality_storage: "granted",
  personalization_storage: "granted",
  security_storage: "granted",
};

export function categoriesToState(cats) {
  // cats: { necessary: true, functional, analytics, advertising }
  return {
    ad_storage: cats.advertising ? "granted" : "denied",
    ad_user_data: cats.advertising ? "granted" : "denied",
    ad_personalization: cats.advertising ? "granted" : "denied",
    analytics_storage: cats.analytics ? "granted" : "denied",
    functionality_storage: cats.functional ? "granted" : "granted",
    personalization_storage: cats.functional ? "granted" : "denied",
    security_storage: "granted",
  };
}

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.state ? parsed : null;
  } catch (e) {
    return null;
  }
}

function gtagSafe() {
  if (typeof window === "undefined") return () => {};
  if (typeof window.gtag === "function") return window.gtag;
  window.dataLayer = window.dataLayer || [];
  return function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
}

export function applyConsent(state) {
  const gtag = gtagSafe();
  gtag("consent", "update", state);
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "cookie_consent_update" });
  }
}

export function setStoredConsent(categories) {
  const state = categoriesToState(categories);
  const payload = {
    categories,
    state,
    savedAt: new Date().toISOString(),
    version: 1,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {}
  applyConsent(state);
  return payload;
}

export function clearStoredConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}
